import { render, staticRenderFns } from "./PackageBuild.vue?vue&type=template&id=7a24caec&scoped=true"
import script from "./PackageBuild.vue?vue&type=script&lang=js"
export * from "./PackageBuild.vue?vue&type=script&lang=js"
import style0 from "./PackageBuild.vue?vue&type=style&index=0&id=7a24caec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24caec",
  null
  
)

export default component.exports